import { all } from 'redux-saga/effects';

import capturarBiometria from './capturarBiometria/saga';
import verificarVersaoServicoBiometria from './verificarVersaoServicoBiometria/saga';

export default all([capturarBiometria, verificarVersaoServicoBiometria]);
